import React, { type ReactNode } from 'react';
import {
  STATUS_PILL_TONE_NEUTRAL,
  type StatusPillTone,
} from './StatusPill.constants';
import { Dot, Root } from './StatusPill.styled';

export interface StatusPillProps {
  /** Visible label, e.g. "Published" / "Draft" / "Failed". */
  children: ReactNode;
  tone?: StatusPillTone;
  /**
   * Optional leading icon (e.g. a Material `lock` glyph for "Published").
   * If omitted and `dot` is true, a small filled circle is shown instead.
   */
  icon?: ReactNode;
  /** Show a small filled-dot indicator before the label. Mutually exclusive with `icon`. */
  dot?: boolean;
  className?: string;
  dataTestId?: string;
}

const StatusPill: React.FC<StatusPillProps> = ({
  children,
  tone = STATUS_PILL_TONE_NEUTRAL,
  icon,
  dot = false,
  className,
  dataTestId = 'status-pill',
}) => {
  const showDot = dot && !icon;
  return (
    <Root
      $tone={tone}
      className={className}
      data-testid={dataTestId}
      data-tone={tone}
    >
      {icon && (
        <span aria-hidden="true" data-testid={`${dataTestId}__icon`}>
          {icon}
        </span>
      )}
      {showDot && <Dot aria-hidden="true" data-testid={`${dataTestId}__dot`} />}
      <span>{children}</span>
    </Root>
  );
};

export default StatusPill;
